import { Routes } from '@angular/router';
import { requiresAuth, projectAuthGuard, ALLOWED_ROLES_ROUTE_DATA_KEY } from '@auth';
import type { ProjectUserRole } from '@models/projects';

export const routes: Routes = [
  {
    path: 'projects',
    loadComponent: () =>
      import('./pages/projects/projects.page').then((m) => m.ProjectsPage),
    canActivate: [requiresAuth],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'projects/:projectId/services',
    loadComponent: () =>
      import('./pages/services/services.page').then((m) => m.ServicesPage),
    canActivate: [requiresAuth, projectAuthGuard],
  },
  {
    path: 'projects/:projectId/customer-doors',
    loadComponent: () =>
      import('./pages/customer-doors/customer-doors.page').then((m) => m.CustomerDoorsPage),
    canActivate: [requiresAuth, projectAuthGuard],
    // Every technician role reports door issues the same way as a customer would.
    data: { [ALLOWED_ROLES_ROUTE_DATA_KEY]: ['Customer', 'ServiceWorker', 'ServiceLeader', 'Admin'] satisfies ProjectUserRole[] },
  },
  {
    path: 'projects/:projectId/services/:serviceId/doors',
    canActivate: [requiresAuth, projectAuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/doors/doors.page').then((m) => m.DoorsPage),
      },
      {
        path: ':doorId/chat',
        loadComponent: () =>
          import('./pages/doors/chat/chat.page').then((m) => m.ChatPage),
      },
      {
        path: ':doorId',
        loadComponent: () =>
          import('./pages/doors/doors.page').then((m) => m.DoorsPage),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'projects',
    pathMatch: 'full',
  },
];
